/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 93f301e2ef80
 */

import { uploadMappingsUpdateUploadMapping } from "../../funcs/uploadMappingsUpdateUploadMapping.js";
import { UploadMappingInput$zodSchema } from "../../models/uploadmappinginput.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: UploadMappingInput$zodSchema.describe(
    `The updated upload mapping folder and URL template.`,
  ),
};

export const tool$uploadMappingsUpdateUploadMapping: ToolDefinition<
  typeof args
> = {
  name: "update-upload-mapping",
  description:
    `Updates an existing upload mapping by changing its remote URL template for a given folder

Updates the URL template for an existing folder mapping`,
  scopes: ["builder"],
  annotations: {
    "title": "Update Upload Mapping",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await uploadMappingsUpdateUploadMapping(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
